// appStore.js
import { create } from 'zustand';

const useAppStore = create((set, get) => ({
  callAppFunction: null,

  setCallAppFunction: (fn) => set({ callAppFunction: fn }),

  lastTriggerParam: null, // observable

  triggerAppFunction: (param) => {
    const fn = get().callAppFunction;
    if (typeof fn === 'function') {
      fn(param);
    }
    set({ lastTriggerParam: param });
  },

  resetTriggerParam: () => set({ lastTriggerParam: null }),
}));



export default useAppStore;
